import React from 'react';
import { motion } from 'framer-motion';

export default function HeroSection({ heroMainImage, heroFloating, whatsappUrl, onViewPups }) {
  return (
    <motion.section
      className="hero"
      id="home"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <div className="hero-content">
        <div className="hero-inner">
          <div className="hero-copy">
            <motion.h1
              initial={{ y: 24, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.15, duration: 0.6, ease: 'easeOut' }}
            >
              Find Your Forever
              <br />
              Friend{' '}
              <motion.span
                className="headline-paws"
                aria-hidden="true"
                animate={{ rotate: [0, 12, -10, 0] }}
                transition={{ duration: 3.6, repeat: Infinity, ease: 'easeInOut' }}
              >
                🐾
              </motion.span>
            </motion.h1>
            <motion.p
              initial={{ y: 18, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.28, duration: 0.6, ease: 'easeOut' }}
            >
              A curated selection of loving, plush pups—raised with exceptional care, thoughtful socialization, and
              devotion to safety, ensuring a joyful beginning in their forever homes.
            </motion.p>
            <motion.button
              className="cta-button"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.38, duration: 0.5, ease: 'backOut' }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={onViewPups}
              type="button"
            >
              🐶 View Available Pups
            </motion.button>
          </div>

          <div className="hero-media" aria-label="Pups photos">
            <motion.div
              className="hero-main"
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.25, duration: 0.7, ease: 'easeOut' }}
              whileHover={{
                scale: 1.01,
                boxShadow: '0 30px 80px rgba(0, 0, 0, 0.48)'
              }}
            >
              <motion.img
                src={heroMainImage}
                alt="Pup"
                loading="eager"
                animate={{ y: [0, -10, 0], scale: [1, 1.01, 1] }}
                transition={{ duration: 6.4, repeat: Infinity, ease: 'easeInOut' }}
              />
            </motion.div>

            {heroFloating.map((src, idx) => (
              <motion.a
                key={src}
                className={`hero-float hero-float-${idx + 1}`}
                href={whatsappUrl}
                target="_blank"
                rel="noreferrer"
                initial={{ opacity: 0, y: 18 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.42 + idx * 0.08, duration: 0.6, ease: 'easeOut' }}
                whileHover={{
                  scale: 1.03,
                  boxShadow: '0 22px 56px rgba(0, 0, 0, 0.35)'
                }}
              >
                <motion.img
                  src={src}
                  alt="Pup"
                  loading="eager"
                  animate={{
                    y: [0, -(14 + idx * 3), 0],
                    x: [0, idx % 2 === 0 ? 6 : -6, 0],
                    rotate: [0, idx % 2 === 0 ? 2 : -2, 0]
                  }}
                  transition={{
                    duration: 5.2 + idx * 0.5,
                    repeat: Infinity,
                    ease: 'easeInOut',
                    delay: idx * 0.18
                  }}
                />
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </motion.section>
  );
}

